import {ApiResponse, ListQueryParams} from '../ApiClient'
import {GetAPIDomain, GetAPIHeaders, GetAPIHeadersPatch} from '../Helper'

export class AccountSettingsQueryParams extends ListQueryParams {
}

export class AccountSettingsClient {
  static async GetFeatures() {
    let apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/accounts/current/features', {
        headers: GetAPIHeaders(),
        credentials: 'include',
      }),
    )
  }

  static async GetCurrent() {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/current', {
        headers: GetAPIHeaders(),
        credentials: 'include',
      }),
    )
  }

  static async GetDefault() {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/default', {
        headers: GetAPIHeaders(),
        credentials: 'include',
      }),
    )
  }

  static async ListAccountTheme(params: AccountSettingsQueryParams) {
    var query =
      (await GetAPIDomain()) + '/account-settings/account-theme' + params.GenerateQueryString()

    return await ApiResponse.Create(() =>
      fetch(query, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      }),
    )
  }

  static async UpdateAccountThemeClients(id: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/account-theme/${id}/update-clients`, {
        headers: GetAPIHeaders(),
        credentials: 'include',
        method: 'POST',
      }),
    )
  }

  static async GetAccountTheme(id: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/account-theme/${id}`, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      }),
    )
  }

  static async DeleteAccountTheme(id: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/account-theme/${id}`, {
        headers: GetAPIHeaders(),
        method: 'DELETE',
        credentials: 'include',
      }),
    )
  }

  static async LinkUserToAccountTheme(id: string, userIds: string[]) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(async () =>
      fetch(apiDomain + `/account-settings/account-theme/${id}/users`, {
        method: 'POST',
        credentials: 'include',
        headers: await GetAPIHeaders(),
        body: JSON.stringify({
          userIds,
        }),
      }),
    )
  }

  static async RemoveUserToAccountTheme(id: string, userId: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/account-theme/${id}/users/${userId}`, {
        headers: GetAPIHeaders(),
        method: 'DELETE',
        credentials: 'include',
      }),
    )
  }

  static async LinkTeamToAccountTheme(id: string, teamIds: string[]) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(async () =>
      fetch(apiDomain + `/account-settings/account-theme/${id}/teams`, {
        method: 'POST',
        headers: await GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          teamIds,
        }),
      }),
    )
  }

  static async RemoveTeamToAccountTheme(id: string, teamId: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/account-theme/${id}/teams/${teamId}`, {
        headers: GetAPIHeaders(),
        method: 'DELETE',
        credentials: 'include',
      }),
    )
  }

  static async UpdateThemeColor(
    id: string,
    primary: string,
    secondary: string,
    iconPrimary: string,
    iconSecondary: string,
    onSite: string,
    onSiteDowLabel: string,
    remote: string,
    remoteDowLabel: string,
    leave: string,
    leaveDowLabel: string,
    noResponse: string,
    noResponseDowLabel: string,
    success: string,
    error: string,
    whatsOnHoliday: string,
    whatsOnEvent: string,
    highlightTeam: string,
    available: string,
    reserved: string,
    inUse: string,
    booked: string,
    item: string,
    activity: string,
    filters: string,
    chartBackground: string,
    actionInactive: string,
    actionBorder: string,
    actionBackground: string,
    assetMapLabel: string,
    ticket: string,
    ticketNotes: string,
    ticketAttachments: string,
    plotOpacity: string,
    name: string,
    active: boolean,
    isDefault: boolean,
    updateValues: boolean,
  ) {

    const apiDomain = await GetAPIDomain()
    const values: any[] = [
      {
        key: 'Primary',
        value: primary,
      },
      {
        key: 'Secondary',
        value: secondary,
      },
      {
        key: 'IconPrimary',
        value: iconPrimary,
      },
      {
        key: 'IconSecondary',
        value: iconSecondary,
      },
      {
        key: 'OnSite',
        value: onSite,
      },
      {
        key: 'OnSiteDowLabel',
        value: onSiteDowLabel,
      },
      {
        key: 'Remote',
        value: remote,
      },
      {
        key: 'RemoteDowLabel',
        value: remoteDowLabel,
      },
      {
        key: 'Leave',
        value: leave,
      },
      {
        key: 'LeaveDowLabel',
        value: leaveDowLabel,
      },
      {
        key: 'NoResponse',
        value: noResponse,
      },
      {
        key: 'NoResponseDowLabel',
        value: noResponseDowLabel,
      },
      {
        key: 'Success',
        value: success,
      },
      {
        key: 'Error',
        value: error,
      },
      {
        key: 'WhatsOnHoliday',
        value: whatsOnHoliday,
      },
      {
        key: 'WhatsOnEvent',
        value: whatsOnEvent,
      },
      {
        key: 'HighlightTeam',
        value: highlightTeam,
      },

      {
        key: 'Available',
        value: available,
      },

      {
        key: 'Reserved',
        value: reserved,
      },
      {
        key: 'InUse',
        value: inUse,
      },
      {
        key: 'Booked',
        value: booked,
      },
      {
        key: 'Item',
        value: item,
      },
      {
        key: 'Activity',
        value: activity,
      },
      {
        key: 'Filters',
        value: filters,
      },
      {
        key: 'ChartBackground',
        value: chartBackground,
      },
      {
        key: 'ActionInactive',
        value: actionInactive,
      },
      {
        key: 'ActionBorder',
        value: actionBorder,
      },
      {
        key: 'ActionBackground',
        value: actionBackground,
      },
      {
        key: 'AssetMapLabel',
        value: assetMapLabel,
      },
      {
        key: 'Ticket',
        value: ticket,
      },
      {
        key: 'TicketNotes',
        value: ticketNotes,
      },
      {
        key: 'TicketAttachments',
        value: ticketAttachments,
      },
      {
        key: 'PlotOpacity',
        value: plotOpacity,
      },
    ]

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/account-theme', {
        method: 'PATCH',
        headers: GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          id,
          name,
          active,
          values: updateValues ? values : null,
          updateValues,
          default: isDefault,
        }),
      }),
    )
  }

  static async UpdateThemeColorSetting(
    id: string,
    name: string,
    active: boolean,
    isDefault: boolean,
  ) {
    var apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/account-theme', {
        method: 'PATCH',
        headers: GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          id,
          name,
          active,
          default: isDefault,
          updateValues: false,
        }),
      }),
    )
  }

  static async CreateThemeColor(name: string) {
    const apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/account-theme', {
        method: 'POST',
        headers: GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          name,
        }),
      }),
    )
  }

  static async CopyThemeColor(themeId: string, name: string) {
    const apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/account-theme/copy', {
        method: 'POST',
        headers: GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({themeId, name}),
      }),
    )
  }

  static async CreateLocalization(name: string) {
    const apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/localization', {
        method: 'POST',
        headers: GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          name,
        }),
      }),
    )
  }

  static async GetLocalization(id: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/localization/${id}`, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      }),
    )
  }

  static async DeleteLocalization(id: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/localization/${id}`, {
        headers: GetAPIHeaders(),
        credentials: 'include',
        method: 'DELETE',
      }),
    )
  }

  static async ListLocalization(params: AccountSettingsQueryParams) {
    var query =
      (await GetAPIDomain()) + '/account-settings/localization' + params.GenerateQueryString()

    return await ApiResponse.Create(() =>
      fetch(query, {
        headers: GetAPIHeaders(),
        credentials: 'include',
      }),
    )
  }

  static async UpdateLocalizationClients(id: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/localization/${id}/update-clients`, {
        headers: GetAPIHeaders(),
        credentials: 'include',
        method: 'POST',
      }),
    )
  }

  static async UpdateLocalizations(
    id: string,
    home: string,
    onSite: string,
    notWorking: string,
    monday: string,
    tuesday: string,
    wednesday: string,
    thursday: string,
    friday: string,
    saturday: string,
    sunday: string,
    name: string,
    active: boolean,
    updateValues: boolean,
    available: string,
    booked: string,
    reserved: string,
    inUse: string,
    item: string,
    isDefault: boolean,
    defaultView?: string,
    connectLabel?: string,
    connectIcon?: string,
    connectView?: string,
    ticketAutoCloseDays?: string,
    ticketBusinessStartHour?: string,
    ticketBusinessEndHour?: string,
  ) {
    const apiDomain = await GetAPIDomain()
    const values: any[] = [
      {
        key: 'Home',
        value: home,
      },
      {
        key: 'OnSite',
        value: onSite,
      },
      {
        key: 'NotWorking',
        value: notWorking,
      },
      {
        key: 'Monday',
        value: monday,
      },
      {
        key: 'Tuesday',
        value: tuesday,
      },
      {
        key: 'Wednesday',
        value: wednesday,
      },
      {
        key: 'Thursday',
        value: thursday,
      },
      {
        key: 'Friday',
        value: friday,
      },
      {
        key: 'Saturday',
        value: saturday,
      },
      {
        key: 'Sunday',
        value: sunday,
      },
      {
        key: 'Available',
        value: available,
      },
      {
        key: 'Booked',
        value: booked,
      },
      {
        key: 'Reserved',
        value: reserved,
      },
      {
        key: 'InUse',
        value: inUse,
      },
      {
        key: 'Item',
        value: item,
      },
      {
        key: 'DefaultView',
        value: defaultView ?? 'Default View',
      },
      {
        key: 'ConnectLabel',
        value: connectLabel ?? 'Connect Day',
      },
      {
        key: 'ConnectIcon',
        value: connectIcon ?? 'fa-duotone fa-solid fa-calendar-users',
      },
      {
        key: 'ConnectView',
        value: connectView ?? 'Full',
      },
      {
        key: 'TicketAutoCloseDays',
        value: ticketAutoCloseDays ?? '7',
      },
      {
        key: 'TicketBusinessStartHour',
        value: ticketBusinessStartHour ?? '8',
      },
      {
        key: 'TicketBusinessEndHour',
        value: ticketBusinessEndHour ?? '17',
      },
    ]

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/localization', {
        method: 'PATCH',
        headers: GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          id,
          name,
          active,
          values: updateValues ? values : null,
          updateValues,
          default: isDefault,
        }),
      }),
    )
  }

  static async UpdateLocalizationSetting(
    id: string,
    name: string,
    active: boolean,
    isDefault: boolean,
  ) {
    var apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/account-settings/localization', {
        method: 'PATCH',
        headers: GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          id,
          name,
          active,
          default: isDefault,
          updateValues: false,
        }),
      }),
    )
  }

  static async LinkUserToLocalization(id: string, userIds: string[]) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(async () =>
      fetch(apiDomain + `/account-settings/localization/${id}/users`, {
        method: 'POST',
        headers: await GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          userIds,
        }),
      }),
    )
  }

  static async RemoveUserToLocalization(id: string, userId: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/localization/${id}/users/${userId}`, {
        headers: GetAPIHeaders(),
        method: 'DELETE',
        credentials: 'include',
      }),
    )
  }

  static async LinkTeamToLocalization(id: string, teamIds: string[]) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(async () =>
      fetch(apiDomain + `/account-settings/localization/${id}/teams`, {
        method: 'POST',
        headers: await GetAPIHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          teamIds,
        }),
      }),
    )
  }

  static async RemoveTeamToLocalization(id: string, teamId: string) {
    var apiDomain = await GetAPIDomain()
    return await ApiResponse.Create(() =>
      fetch(apiDomain + `/account-settings/localization/${id}/teams/${teamId}`, {
        headers: GetAPIHeaders(),
        credentials: 'include',
        method: 'DELETE',
      }),
    )
  }
}
